import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioQuery = (id: number, enabled = true) => {
	return useQuery({
		queryKey: PortfolioKeys.portfolioDetail(id),
		queryFn: processResponse(() => getPortfolioIdV2(id)),
		enabled,
	});
};
